import { render, staticRenderFns } from "./SelectExpertModal.vue?vue&type=template&id=b10b8024&scoped=true"
import script from "./SelectExpertModal.vue?vue&type=script&lang=js"
export * from "./SelectExpertModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10b8024",
  null
  
)

export default component.exports